import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Formik } from "formik";

import { SocialCoachSessionService } from "@/services";
import { ChangePassword } from "@/components";
import { validationSchema } from "./validations";
import { URLS } from "@/utils";

interface OwnProps {
  password?: string;
  confirmPassword?: string;
  isPlayer: boolean; // TODO: REMOVE
}

interface PathProps {
  userId: string;
  actionToken: string;
}

type Props = OwnProps & RouteComponentProps<PathProps>;

const IntegratedChangePassword: React.FC<Props> = ({
  history,
  password = "",
  confirmPassword = "",
  match: {
    params: { userId, actionToken },
  },
}) => {
  const [successMessage, setSuccessMessage] = React.useState<string>();
  const [isSuccess, setIsSuccess] = React.useState(false);

  const changeForm = (): JSX.Element => {
    return (
      <Formik
        validateOnBlur={true}
        validateOnChange={true}
        initialValues={{ password, confirmPassword }}
        validationSchema={validationSchema}
        onSubmit={async (
          { password: pwd, confirmPassword: confirmpwd },
          { setSubmitting, setErrors, validateForm }
        ) => {
          try {
            setSubmitting(true);
            const errors = await validateForm({ password: pwd, confirmPassword: confirmpwd });
            if (errors && Object.values(errors).length > 0 && actionToken && userId) {
              setErrors(errors);
            } else {
              setSubmitting(true);
              await SocialCoachSessionService.changePassword(userId, actionToken, pwd!);
              setSubmitting(false);
              setSuccessMessage("Password changed successfully!");
              setIsSuccess(true);
              setTimeout(() => {
                history.push(URLS.login);
              }, 3000);
            }
          } catch (e) {
            const errorString = String(e);
            if (errorString.includes("expired")) {
              if (confirm("Your link has expired. Please request a new link")) {
                history.push(URLS.forgotPassword);
              }
            } else {
              setErrors({
                password: errorString,
                confirmPassword: undefined,
              });
            }
          }
        }}
      >
        {({ errors, handleChange, handleSubmit, isSubmitting }) => (
          <ChangePassword
            subtitle={successMessage}
            messages={{
              error: Object.values(errors) as string[],
            }}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            isSuccess={isSuccess}
          />
        )}
      </Formik>
    );
  };
  return changeForm();
};

export const ChangePasswordForm = withRouter(IntegratedChangePassword);
